import * as liveServices from '@/services/liveServices';
import * as userServices from '@/services/userServices';
import * as storageServices from '@/services/storageServices';
//import * as googleApiServices from '@/services/googleApiServices';
import * as DateTime from '@/utils/date';

export default {
  namespaced: true,
  state: {
    initialized: false,
    recentLives: [],
    upComingLives: [], // ログイン中のユーザーのupComingLiveしか入っていないことに注意
    upComingAllLives: [], //TODO: これをupComingLivesにして、userごとのFilterはgettersで行うべき（チューニングとかは未配慮）
    endedLives: [],
    upComingLive: {},
    recentLive: {},
    reserveLive: {},
    commentRefObj: {},
    liveComments: [],
    gifts: [],
  },
  mutations: {
    updateUpComingLive(state, upComingLive) {
      state.upComingLive = upComingLive;
    },
    updateUpComingAllLives(state, upComingAllLives) {
      state.upComingAllLives = upComingAllLives;
    },
    updateUpComingLives(state, upComingLives) {
      state.upComingLives = upComingLives;
    },
    updateRecentLive(state, recentLive) {
      state.recentLive = recentLive;
    },
    updateRecentLives(state, recentLives) {
      state.recentLives = recentLives;
    },
    updateGifts(state, gifts) {
      state.gifts = gifts;
    },
    updateReserveLive(state, reserveLive) {
      state.reserveLive = reserveLive;
    },
    initStore(state) {
      state.initialized = false;
      state.recentLives = [];
      state.upComingLives = [];
      state.upComingAllLives = [];
      state.endedLives = [];
      state.upComingLive = {};
      state.recentLive = {};
      state.reserveLive = {};
      state.commentRefObj = {};
      state.liveComments = [];
      state.gifts = [];
    },
  },
  actions: {
    async initStore({ commit }) {
      commit('initStore');
    },
    async loadUpComingAllLives({ commit }) {
      const upComingLives = await liveServices.getAllUpComingLives();
      commit('updateUpComingAllLives', upComingLives);
    },
    async loadUpComingLivesByUserId({ commit }, payload) {
      const upComingLives = await liveServices.getUpcomingLivesByPerformerId(
        payload.userId,
        payload.limit
      );

      commit('updateUpComingLives', upComingLives);
    },
    async addUpComingLive(_, payload) {
      const performerDocRef = userServices.getUserDocRef(payload.userId);
      const storageFolderPath = `lives/${payload.userId}/thumbnails`;

      let thumbnailURL = payload.thumbnailURL;
      if (payload.imageFile) {
        thumbnailURL = await storageServices.uploadPhoto(
          storageFolderPath,
          payload.imageFile
        );
      }

      DateTime.trimJSSeconds(payload.startAt);
      DateTime.trimJSSeconds(payload.endAt);
      DateTime.trimJSSeconds(payload.reserveStartAt);
      DateTime.trimJSSeconds(payload.reserveEndAt);

      const liveDoc = {
        performerDocRef: performerDocRef,
        title: payload.title,
        thumbnailURL: thumbnailURL,
        startAt: payload.startAt,
        endAt: payload.endAt,
        reserveStartAt: payload.reserveStartAt,
        reserveEndAt: payload.reserveEndAt,
      };
      await liveServices.createUpComingLive(payload.id, liveDoc);
    },
    async updateUpComingLive(_, payload) {
      const storageFolderPath = `lives/${payload.userId}/thumbnails`;

      let thumbnailURL = payload.thumbnailURL;
      if (payload.imageFile) {
        thumbnailURL = await storageServices.uploadPhoto(
          storageFolderPath,
          payload.imageFile
        );
      }

      DateTime.trimJSSeconds(payload.startAt);
      DateTime.trimJSSeconds(payload.endAt);
      DateTime.trimJSSeconds(payload.reserveStartAt);
      DateTime.trimJSSeconds(payload.reserveEndAt);

      const liveDoc = {
        title: payload.title,
        thumbnailURL: thumbnailURL,
        startAt: payload.startAt,
        endAt: payload.endAt,
        reserveStartAt: payload.reserveStartAt,
        reserveEndAt: payload.reserveEndAt,
      };
      await liveServices.updateUpComingLive(payload.id, liveDoc);
    },
    async loadUpComingLive({ commit }, liveId) {
      const upComingLive = await liveServices.getUpComingLiveByLiveId(liveId);
      if (!upComingLive) {
        commit('updateUpComingLive', null);
        return;
      }

      const livePerformerSnapshot = await upComingLive.performerDocRef.get();
      const performerDoc = livePerformerSnapshot.data();

      commit('updateUpComingLive', {
        performerId: upComingLive.performerDocRef.id,
        performerName: performerDoc?.nickname,
        performerPhotoURL: performerDoc?.photoURL,
        startAt: upComingLive.startAt,
        endAt: upComingLive.endAt,
        reserveStartAt: upComingLive.reserveStartAt,
        reserveEndAt: upComingLive.reserveEndAt,
        thumbnailURL: upComingLive.thumbnailURL,
        title: upComingLive.title
      });
    },
    async loadRecentLive({ commit }, liveId) {
      const recentLive = await liveServices.getRecentLiveByLiveId(liveId);
      if (!recentLive) {
        commit('updateRecentLive', null);
        return;
      }

      const livePerformerSnapshot = await recentLive.performerDocRef.get();
      const performerDoc = livePerformerSnapshot.data();
      commit('updateRecentLive', {
        performerId: recentLive.performerDocRef.id,
        performerName: performerDoc?.nickname,
        performerPhotoURL: performerDoc?.photoURL,
        playbackUrl: recentLive.playbackUrl,
        startAt: recentLive.startAt,
        thumbnailURL: recentLive.thumbnailURL,
        nowReserveId: recentLive.nowReserveId,
        title: recentLive.title
      });
    },
    async loadRecentLivesByUserId({ commit }, payload) {
      const recentLives = await liveServices.getRecentLivesByPerformerId(
        payload.userId,
        payload.limit
      );

      commit('updateRecentLives', recentLives);
    },
    async loadRecentLivesInHomeScreen({ commit }) {
      const recentLives = await liveServices.getAllRecentLives();
      commit('updateRecentLives', recentLives);
    },
    async loadRecentLives({ commit }) {
      const recentLives = await liveServices.getAllRecentLives();
      commit('updateRecentLives', recentLives);
    }
  },
  getters: {
    playbackUrl(state) {
      return state.recentLive.playbackUrl;
    },
    performerId(state) {
      return state.recentLive.userId;
    },
    upComingLives(state) {
      return state.upComingLives;
    },
    recentLives(state) {
      return state.recentLives;
    },
    gifts(state) {
      return state.gifts;
    }
  }
};
